import KindEditor from '@/components/index'
const install = function(Vue) {
    if (install.installed) return
    install.installed = true
    Vue.component('editor', KindEditor)
}
 
export default install


// WEBPACK FOOTER //
// ./src/utils/kindeditor.js